import * as React from "react";
import { observer } from "mobx-react";

import { UitkLayoutGridItem } from "uitk-react-layout-grid";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkEmptyState } from "uitk-react-empty-state";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkHeading, UitkText } from "uitk-react-text";

import { locKeys } from "components/flexComponents/WizardPackagePWA/l10n.ts";
import { LOBState, PackageWizardState } from "stores/wizard/state";
import { Experiment, isVariantEnabled } from "components/utility/experiment";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { allowedVariantsForPackageWizardMultiLOB } from "components/shared/StorefrontWizard/constants";
import { UitkSpacing } from "uitk-react-spacing";

export interface PackageErrorStateProps {
  lobsMissing: number;
  packageWizardState: PackageWizardState;
  lobState: LOBState;
  context?: ExtendedContextStore;
}

const { lobErrorHeadingsMap, lobErrorBodyMap, lobErrorHeadingsMapMultiLOB, lobErrorBodyMapMultiLOB } = locKeys;

export const PackageErrorState: React.FunctionComponent<PackageErrorStateProps> = observer(
  ({ context, lobsMissing, packageWizardState, lobState }) => {
    const { PWA_Package_Wizard_Multi_LOB } = Experiment;
    const { formatText } = useLocalization();

    const isMultiLOBWizardEnabled = allowedVariantsForPackageWizardMultiLOB.some((variant) =>
      isVariantEnabled(context, PWA_Package_Wizard_Multi_LOB, variant)
    );

    const heading = formatText(
      isMultiLOBWizardEnabled ? lobErrorHeadingsMapMultiLOB[lobsMissing] : lobErrorHeadingsMap[lobsMissing]
    );
    let body = formatText(
      isMultiLOBWizardEnabled ? lobErrorBodyMapMultiLOB[lobsMissing] : lobErrorBodyMap[lobsMissing]
    );
    const { updateInvalidFormsState } = packageWizardState;

    body = lobsMissing === 99 ? formatText(lobState.config.heading.lobNotSupported) : body;

    updateInvalidFormsState();

    return (
      <UitkSpacing margin={{ blockend: "four" }}>
        <UitkLayoutGridItem colSpan="all">
          <UitkEmptyState>
            <UitkIcon name="search" size={UitkIconSize.LARGE} />
            <UitkHeading level={2} size={500}>
              {heading}
            </UitkHeading>
            <UitkText>{body}</UitkText>
          </UitkEmptyState>
        </UitkLayoutGridItem>
      </UitkSpacing>
    );
  }
);
